import { render, staticRenderFns } from "./FormatEditMenuContainer.vue?vue&type=template&id=474a1a0c&scoped=true&"
import script from "./FormatEditMenuContainer.vue?vue&type=script&lang=ts&"
export * from "./FormatEditMenuContainer.vue?vue&type=script&lang=ts&"
import style0 from "./FormatEditMenuContainer.vue?vue&type=style&index=0&id=474a1a0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474a1a0c",
  null
  
)

export default component.exports